module.exports = __webpack_public_path__ + "static/media/tablets3.8e845d9d.png";